import api from './api';
import UserService from './user.service';
import WalletService from './wallet.service';
import router from '@/router';
import { vueRoutes } from '@/router/route-const';
class AuthService {
  login(user) {
    return api
      .post('/identity/v1/auth', {
        login: user.login,
        password: user.password,
      })
      .then((response) => {
        if (response.data.access_token) {
          const userWithCredentials = response.data;
          userWithCredentials.login = user.login;
          UserService.setUser(userWithCredentials);
        }
        return response.data;
      });
  }

  logout = async () => {
    await UserService.removeUser();
    await WalletService.removePrivateData();
    await router.push(vueRoutes.login);
  };
}

export default new AuthService();
